module.exports = __webpack_public_path__ + "static/media/commercial-construction.288aaf8e.jpg";